<div class="add-class">
    <div class="table-operations">
        <button nz-button nzType="primary" [nzSize]="'large'" [routerLink]="'/admin/v3/resources/audio/index'">
            <i nz-icon nzType="left" nzTheme="outline"></i>返回列表</button>
    </div>
    <form nz-form [formGroup]="validateForm">
        <nz-form-item>
            <nz-form-label [nzSpan]="7" nzRequired>套系名称</nz-form-label>
            <nz-form-control [nzSpan]="12" nzHasFeedback nzErrorTip="请正确输入套系名称！">
                <input nz-input formControlName="name" (ngModelChange)="changeTitle($event)" placeholder="套系标题">
            </nz-form-control>
        </nz-form-item>
        <nz-form-item>
            <nz-form-label [nzSpan]="7" nzRequired>设置封面</nz-form-label>
            <nz-form-control [nzSpan]="12" >
                <div class="series-cover">
                    <input nz-input type="hidden" formControlName="cover_id">
                    <app-upload-image-with-preview
                            [picUrl]="coverUrl"
                            [picItem]="null"
                            (imageUploaded)="onImageUploadSuccess($event)"
                    ></app-upload-image-with-preview>
                </div>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item>
            <nz-form-label [nzSpan]="7" nzRequired>添加音频</nz-form-label>
            <nz-form-control [nzSpan]="12" >
                <div class="book-images book-field">
                    <input nz-input type="hidden" formControlName="finishUploading">


                    <nz-upload
                            [nzMultiple]="false"
                            nzAccept = "audio/mp3"

                            [nzBeforeUpload]="handleBeforeUpload">
                        <button nz-button [disabled]="_currentUploadCount !== 0">
                            <i nz-icon nzType="upload"></i><span>Click to Upload Audio</span>
                        </button>
                    </nz-upload>

                    <!--<nz-upload-->
                            <!--nzType="drag"-->
                            <!--[nzMultiple]="true"-->
                            <!--nzAccept = "audio/mp3"-->

                            <!--[nzBeforeUpload]="handleBeforeUpload">-->
                        <!--<p class="ant-upload-drag-icon">-->
                            <!--<i nz-icon type="inbox"></i>-->
                        <!--</p>-->
                        <!--<p class="ant-upload-text">Click or drag audio file to this area to upload</p>-->
                        <!--<p class="ant-upload-hint">Support for a single or bulk upload. </p>-->
                    <!--</nz-upload>-->





                    <!--nzListType="picture"-->
                    <!--nzAction="https://jsonplaceholder.typicode.com/posts/"-->

                    <!--<app-upload-audio-->
                            <!--[audioUrl]=""-->
                            <!--(audioUploaded)="onAudioUploadSuccess($event)"></app-upload-audio>-->

                    <div class="audio-list" style="margin-top: 2em;">
                        <ngx-sortable
                                listStyle="{
                                width: '100%',
                                height: '400px',
                            }"
                                [items]="displayFilesList"
                                [name]="'Audio List'"
                                (listSorted)="listOrderChanged($event)">
                            <ng-template let-item>
                                <div class="sortable-list-item">
                                    <label style="margin-right: 1rem;flex: 1 1 auto;">{{item.name}}</label>
                                    <app-upload-audio style="flex: 0 0 auto;"
                                            [audioItem]="item" [audioUrl]="item.url"
                                            [showUploadBtn]="false"
                                                      (audioUploadFailure)="onAudioUploadFailure($event)"
                                            (audioUploaded)="onAudioUploadSuccess($event)"></app-upload-audio>
                                    <i class="remove" *ngIf="item.res_id" (click)="removeAudioFile(item, $event)" nz-icon nzType="close-circle" nzTheme="outline"></i>
                                </div>
                                <nz-divider style="margin: 0"></nz-divider>
                            </ng-template>
                        </ngx-sortable>
                    </div>


                </div>
            </nz-form-control>
        </nz-form-item>




        <nz-form-item>
            <nz-form-control [nzOffset]="7" [nzSpan]="12">
                <!--(ngSubmit)="submitForm($event,validateForm.value)"-->
                <button style="margin-right:1rem;" nz-button nzType="primary" (click)="submitForm($event, validateForm.value)" [disabled]="!validateForm.valid">Submit</button>
                <!--<button nz-button (click)="resetForm($event)">Reset</button>-->
            </nz-form-control>
        </nz-form-item>
    </form>
</div>
